import React from 'react';

export default ({ loading, name, className }) => {
  const disabled = loading ? { disabled: 'desabled' } : {};
  return (
    <input
      type="submit"
      className={`btn ${className}`}
      value={loading ? 'Carregando...' : name}
      {...disabled}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Submit/index.js